import { render, staticRenderFns } from "./AccountUpdate.vue?vue&type=template&id=054745e1&scoped=true&"
import script from "./AccountUpdate.vue?vue&type=script&lang=js&"
export * from "./AccountUpdate.vue?vue&type=script&lang=js&"
import style0 from "./AccountUpdate.vue?vue&type=style&index=0&id=054745e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "054745e1",
  null
  
)

export default component.exports